module.exports = {"542223100":"吉雄镇","542223101":"岗堆镇","542223102":"甲竹林镇","542223103":"江塘镇","542223104":"杰德秀镇","542223200":"朗杰学乡","542223201":"昌果乡","542223202":"东拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542223.json
// module id = 2541
// module chunks = 0